import type { BrowserOptions } from "@similarweb/sentry-logger";
import Sentry from "@similarweb/sentry-logger";

import { createBaseConfig, NETWORK_RESPONSE_HEADERS_WHITE_LIST, DENY_URLS } from "./base-config";

const createProductionConfig = (buildId: string): BrowserOptions => {
    const baseConfig = createBaseConfig(buildId);
    const NETWORK_DETAILS_URLS_WHITE_LIST = [
        "https://pro.similarweb.com",
        "https://gro.similarweb.com",
        "https://d1i9adzftlxh7.cloudfront.net",
        "https://d6h0qoccjkmh8.cloudfront.net",
    ];
    return {
        ...baseConfig,
        debug: false,
        environment: "Production",
        sampleRate: 0.5,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.integrations.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                stickySession: true,
                networkDetailAllowUrls: NETWORK_DETAILS_URLS_WHITE_LIST,
                networkResponseHeaders: NETWORK_RESPONSE_HEADERS_WHITE_LIST,
            }),
        ],
        denyUrls: DENY_URLS,
    };
};

export default createProductionConfig;
